import type { RescueDevicesProgramData } from './rescueQueries';

export type DevicesAccess = 'loading' | 'active' | 'selfEnroll' | 'notJoined' | 'waitlisted';

/** Which Fi Devices experience the rescue gets, shared by the Devices page and the Dashboard card. */
export function devicesAccess(data: RescueDevicesProgramData | undefined): DevicesAccess {
  const program = data?.rescueDevicesProgram;
  if (!program) {
    return 'loading';
  }
  if (program.approved) {
    return 'active';
  }
  if (program.waitlistEnabled) {
    return program.waitlist ? 'waitlisted' : 'notJoined';
  }
  return program.enrolled ? 'active' : 'selfEnroll';
}

export function isOnWaitlistPath(access: DevicesAccess) {
  return access === 'notJoined' || access === 'waitlisted';
}
